<template>
  <div class="grids is-3-desktop gap-20-desktop">
    <div class="cv-card">
      <p>
        <label>Employer Views</label>
        <span class="count">0</span>
      </p>
    </div>

    <div class="cv-card">
      <p>
        <label>Applied Jobs</label>
        <span class="count">{{ seeker.appliedJob }}</span>
      </p>
    </div>

    <div class="cv-card">
      <p>
        <label>Saved Jobs</label>
        <span class="count">{{ seeker.saveJob }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["seeker"],
};
</script>

<style lang="scss" scoped>
p {
  display: flex;
  justify-content: space-between;
  span {
    font-size: var(--lg-font);
    color: var(--primary-color);
  }
}
</style>
